module.exports = __webpack_public_path__ + "img/alien.15e817d1.png";